import React, { useEffect, useState, useRef } from 'react';
import { withRouter,useHistory } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import moment from 'moment';
import UserAvatar from '../../../../components/UserAvatar';
import TextMap from '../../../../helpers/TextMap';
import SelectProjectMemberPopup from './../SelectProjectMemberPopup';
import ProjectContact from './../ProjectContact';
import ComboBox from '../../../../components/ComboBox';
import LoadingDots from '../../../../components/LoadingDots';
import DataCollector from '../../../../components/DataCollector';
import SelectUserComboBox from '../../../../components/SelectUserComboBox';
import dataModel from '../../../../models/DataModel';
import { location_shallow } from '../../../../dao/collections/LocationsCollection';
import DatePicker from '../../../../components/DatePicker';
import { location_root } from '../../../../dao/collections/LocationsCollection';
import { project_root } from '../../../../dao/ProjectsDAO';
import DataSource from '../../../../dao/DataSource/DataSource';
import CollectionDataSource from '../../../../dao/DataSource/CollectionDataSource';
import KeyMemberDisplay from '../../../../components/KeyMemberDisplay';
import CreateNewProjectGroup from './../CreateNewProjectGroup';
import ProjectGroupService from '../../../../services/projectGroupService';
import locationsService from '../../../../services/locationsService';
import './CreateNewProject.scss';
import Input from '../../../../components/Input';
import Textarea from '../../../../components/Textarea';

const user_complete = {
  additionalFields: ['profile_image'], role: { }, companies: { }, company_vendor_users: { vendor_user: { additionalFields: ['profile_image'], role: { }, companies: { } } }, 
};

const projectTypeDescriptor = { 
  project_type: {
    project_templates: {
      markets: {},
    },
  },
};

const intialProjectGroupListButton = { type: 'create', name: '+ Create Project Group' };

const customFieldTypes = [
  { type: '1', name: 'Text' },
  { type: '2', name: 'Decimal' },
  { type: '3', name: 'Integer' },
  { type: '4', name: 'Yes/No' },
  { type: '5', name: 'Selection List' },
];

// TODO: reduce complexity / break into sub-components
const CreateNewProject = ({
  dataModel,
  currentCompany,
  currentUser,
  build,
}) => {

  const project_for_edit = {
    id: -1,
    company_id: currentCompany.id,
    project: {
      project_manager: {
        role: {},
        companies: {},
      },
      project_type: {},
      project_template: {},
      location: { market: {}, location_users: { user: {} } },
      market: {},
      project_users: { user: {} },
      project_contacts: { user: {} },
      users: user_complete,
      company: {},
      customers: {},
      custom_project_settings: {},
      teams: { users: {} },
      isSaving: false,
      isProjectNew: false,
    },
  };
  
  const textMap = new TextMap();
  const accent_color = currentCompany ? currentCompany.accent_color : '#9b9b9b';
  const history = useHistory();

  const marketsDataSource = useRef(null);
  const locationsDataSource = useRef(null);
  const locationDataSource = useRef(null);
  const projectTypesDataSource = useRef(null);
  const projectManagersDataSource = useRef(null);

  const [projectName, setProjectName] = useState('New Project');
  const [marketsList, setMarketsList] = useState([]);
  const [loadingMarkets, setLoadingMarkets] = useState(false);
  const [selectedMarket, setSelectedMarket] = useState(null);
  const [loadingLocations, setLoadingLocations] = useState(false);
  const [marketLocations, setMarketLocations] = useState([]);
  const [totalLocation, setTotalLocation] = useState(null);
  const [locationsList, setLocationsList] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [projectLocation, setProjectLocation] = useState(null);
  const [loadingProjectTypes, setLoadingProjectTypes] = useState(false);
  const [projectTypesList, setProjectTypesList] = useState([]);
  const [selectedProjectType, setSelectedProjectType] = useState(null);
  const [projectTemplatesList, setProjectTemplatesList] = useState([]);
  const [selectedProjectTemplate, setSelectedProjectTemplate] = useState(null);
  const [projectGroupsList, setProjectGroupsList] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [isCreateNewPGPopup, setIsCreateNewPGPopup] = useState(null);
  const [created_at, setCreated_at] = useState(null);
  const [due_date, setDue_date] = useState(null);
  const [projected_start_date, setProjected_start_date] = useState(null);
  const [disableDatePicker, setDisableDatePicker] = useState(false);
  const [contractId, setContractId] = useState(null);
  const [guid, setGuid] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState([]);
  const [customersList, setCustomersList] = useState([]);
  const [projectManagersList, setProjectManagersList] = useState([]);
  const [selectedprojectManager, setSelectedProjectManager] = useState(null);
  const [notifyUsers, setNotifyUsers] = useState([]);
  const [project_contacts, setProject_contacts] = useState([]);
  const [allMarketUsers, setAllMarketUsers] = useState([]);
  const [projectContact, setProjectContact] = useState(null);
  const [notes, setNotes] = useState('');
  const [selectedFieldType, setSelectedFieldType] = useState(customFieldTypes[0]);
  const [customSetting, setCustomSetting] = useState({});
  const [customProjectSettings, setCustomProjectSettings] = useState([]);
  const [selectedCustomSetting, setSelectedCustomSetting] = useState(null);
  const [displayAddMember, setDisplayAddMember] = useState(false);
  const [closeProjectMemberPopup, setCloseProjectMemberPopup] = useState(false);
  const [popupPosition, setPopupPosition] = useState({ X: 0, Y: 0 });
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [displayEditMember, setDisplayEditMember] = useState(false);
  const [displayedUserInfo, setDisplayedUserInfo] = useState(null);
  const [project,setProject] = useState(project_for_edit);
  const [areRequiredFieldFilled, setAreRequiredFieldFilled] = useState(false);

  useEffect(() => {
    getMarkets();
    handleProjectGroupsRetrieval();

    let companyDataSource = new DataSource('Company', currentCompany.id, { company: { customers: {} } }, handleCompanyUpdate);
    companyDataSource.get();

    return () => {
      if (marketsDataSource.current) {
        marketsDataSource.current.release();
        marketsDataSource.current = null;
      }
      if (locationsDataSource.current) {
        locationsDataSource.current.release();
        locationsDataSource.current = null;
      }
      if (locationDataSource.current) {
        locationDataSource.current.release();
        locationDataSource.current = null;
      }
      if (projectTypesDataSource.current) {
        projectTypesDataSource.current.release();
        projectTypesDataSource.current = null;
      }
      if (companyDataSource) {
        companyDataSource.release();
        companyDataSource = null;
      }
      if (projectManagersDataSource.current) {
        projectManagersDataSource.current.release();
        projectManagersDataSource.current = null;
      }
    };
  }, []);

  useEffect(() => {
    let usersDataSource = null;
    if(selectedMarket){
      getLocations(selectedMarket);
      getProjectTypes(selectedMarket);
      getProjectManagers(selectedMarket);

      usersDataSource = new CollectionDataSource('MarketUsersCollection', 'User', { user: {} }, handleUsersRetrieval, null, null, null, null, null, selectedMarket.id);
      usersDataSource.current();
    }

    return () => {
      if (usersDataSource) {
        usersDataSource.release();
        usersDataSource = null;
      }
    };
  }, [selectedMarket]);

  useEffect(() => {
    setProject((prev) => ({
      ...prev, // Retain the previous state
      id: -1,
      name: projectName.trim() || prev.name,
      market_id: selectedMarket && selectedMarket.id || prev.market_id,
      location_id: selectedLocation && selectedLocation.id || prev.location_id,
      project_type_id: selectedProjectType && selectedProjectType.id || prev.project_type_id,
      project_template_id: selectedProjectTemplate && selectedProjectTemplate.id || prev.project_template_id,
      project_group_id: selectedGroup && selectedGroup.id || prev.project_group_id,
      created_at: created_at || prev.created_at,
      due_date: due_date || prev.due_date,
      contract_id: contractId || prev.contract_id,
      customers_id: selectedCustomer && selectedCustomer.id || prev.customers_id,
      customers: selectedCustomer,
      project_manager_id: selectedprojectManager && selectedprojectManager.id || prev.project_manager_id,
      project_manager: selectedprojectManager || prev.project_manager,
      notify_users: notifyUsers || prev.notify_users, 
      project_contacts: project_contacts || prev.project_contacts,
      notes: notes || prev.notes,
      custom_project_settings: customProjectSettings || prev.custom_project_settings,
      users: users || prev.users,
      guid: guid || prev.guid,
    }));
    if(projectName && selectedMarket && selectedLocation && selectedProjectType && selectedProjectTemplate){
      setAreRequiredFieldFilled(true);
    }
    else{
      setAreRequiredFieldFilled(false);
    }
    if(!dataModel.dataChanged){
      dataModel.dataChanged = true;
    }
  }, [projectName,
    selectedMarket,
    selectedLocation,
    selectedProjectType,
    selectedProjectTemplate,
    selectedGroup,
    created_at,
    due_date,
    contractId,
    selectedCustomer,
    selectedprojectManager,
    notifyUsers,
    project_contacts,
    notes,
    customProjectSettings,
    users]
  );

  const handleCancelCreateProject = () => {
    const message = textMap.queryDataChanged;

    dataModel.showGlobalModal('SYSTEM_POPUP', {
      message: message,
      cancelButtonText: textMap.no.toUpperCase(),
      okButtonText: textMap.yes.toUpperCase(),
      width: 300,
      height: 180,
      handleOwnerOk: () => {
        history.push('/projects/summary');
        dataModel.dataChanged = false;
      },
    });
  };

  const handleSaveProject = () =>{
    if(project){
      dataModel.projectsDAO.createProject(project, { recordDescriptor: project_root })
      .then(res=>{
        if(res.id){
          addMembers(res, project.users);
        }
        history.push('/projects/'+ res.id);
        dataModel.dataChanged = false;
      });
    }
  };

  const addMembers = (project, members) => {
    for (let member of members) {
      addMemberToProject(member, project);
    }
  };

  const isUser = (member) => {
    return member.first_name || member.last_name;
  };

  const addMemberToProject = (member, project) => {
    if (isUser(member)) {
      if (project.users && !project.users.find(usr => usr.id == member.id)) {
        project.users.push(member);
      }
      dataModel.projectsDAO.addUserToProject(member, project)
      .then((project) => {
      })
      .catch(error => {
        const clonedProject = _.cloneDeep(this.state.project);
        _.remove(clonedProject.users, usr => usr.id == member.id);
      });
    }
    else {
      if (project.teams && !project.teams.find(team => team.id == member.id)) {
        project.teams.push(member);
      }
      dataModel.teamsDAO.addTeamProject(member, project.id, null, null, null)
      .then((team) => {
      })
      .catch(error => {
        const clonedProject = _.cloneDeep(this.state.project);
        _.remove(clonedProject.teams, team => team.id == member.id);
      });
    }
  };

  const getMarkets = () => {
    setLoadingMarkets(true);
    marketsDataSource.current = new CollectionDataSource('MarketsCollection', 'Market', { market: {} }, handleMarketsRetrieval,
      'MarketsForProjectCrud', currentUser.id, currentCompany.id);
    marketsDataSource.current.current();
  };

  const handleMarketsRetrieval = (markets) => {
    setLoadingMarkets(false);
    const marketOptions = markets.map((market) => {
      return { type: market.id, name: market.code, market: market };
    });
    setMarketsList(marketOptions);
  };

  const handleMarketSelection = (type, option) => {
    if (!selectedMarket || selectedMarket.id != option.type) {
      setSelectedMarket(option.market);
      // Changing the market refetches the project types and templates, so any
      // previously selected type/template may no longer be valid for the new
      // market. Clear them and force the user to select again.
      setSelectedProjectType(null);
      setSelectedProjectTemplate(null);
      setProjectTemplatesList([]);
    }
  };

  const getLocations = (market) => {
    if (!(marketLocations && marketLocations.length > 0) ||
        (selectedMarket && market.id != selectedMarket.id) ||
        (project && market.id != project.market_id)) {
      setLoadingLocations(true);
      if (locationsDataSource.current) {
        locationsDataSource.current.release();
        locationsDataSource.current = null;
      }
  
      locationsDataSource.current = new CollectionDataSource('LocationsCollection', 'Location', location_shallow,
        handleLocationsRetrieved, 'forProjectCrud', 12, null, currentUser.id,
        currentCompany.id, 'market_' + (market ? market.id : selectedMarket && selectedMarket.id), null, location_shallow,
        (market ? market.id : selectedMarket && selectedMarket.id));
      locationsDataSource.current.current();
    }
  };

  const handleLocationsRetrieved = (currentData, action, acData, fetchedData) => {
    handleLocationsSet(currentData);
  };

  const handleLocationsSet = (currentData) => {
    if (currentData) {
      setMarketLocations(currentData.locations);
      setLoadingLocations(false);
      if(!totalLocation){
        setTotalLocation(currentData.meta.total_records);
      }
      createLocationOptions(currentData.locations);
    }
  };

  const createLocationOptions = (locations) => {
    const locationsList = locations.map(location => {
      let locationOption = { type: location.id, name: location.name, location: location };
      return locationOption;
    });
    setLocationsList(locationsList);
  };

  const handleLocationSelection = (type, option) => {
    if (option) {
      if (locationDataSource.current) {
        locationDataSource.current.release();
        locationDataSource.current = null;
      }
      setSelectedLocation(option.location);
      //handling for location contacts here
      if ((!option.location.latitude && !option.location.longitude) ||
        !option.location.city || !option.location.market) {
        locationDataSource.current = new DataSource('Location', option.location.id, location_root, handleLocationRetrieval);
        locationDataSource.current.get();
      }
    }
  };

  const handleLocationRetrieval = (foundLocation) => {
    setProjectLocation(foundLocation);
  };

  const getProjectTypes = (market) => {
    setLoadingProjectTypes(true);
    projectTypesDataSource.current = new CollectionDataSource('ProjectTypesCollection', 'ProjectTypes', projectTypeDescriptor,
      handleProjectTypesRetrieval, 'ProjectTypesForProjectCrud', null, currentUser.id, currentCompany.id, market.id, 'market_' + market.id, projectTypeDescriptor, true);
    // Drive the loading indicator off the fetch promise so it stays visible for the
    // entire duration of the /project_types request, regardless of how many times the
    // datasource fires the retrieval callback (it fires a synchronous 'prefetch' pass
    // before the request resolves) or whether the result ends up empty.
    const fetchPromise = projectTypesDataSource.current.current(null, true);
    if (fetchPromise) {
      fetchPromise.finally(() => setLoadingProjectTypes(false));
    }
    else {
      setLoadingProjectTypes(false);
    }
  };

  const handleProjectTypesRetrieval = (project_types, action) => {
    // The datasource fires this callback twice: once as a 'prefetch' pass with the
    // cached collection object (before the /project_types request resolves) and again
    // with the real array. Ignore the prefetch pass so we don't clobber the list with
    // stale/empty data while the real data is still loading.
    if (action === 'prefetch') {
      return;
    }
    if (project_types) {
      const projectTypes = getProjectTypesForMarket(selectedMarket && selectedMarket.id, project_types);
      let project_typesList = projectTypes.map((projectType) => {
        return { type: projectType.id, name: projectType.name, project_type: projectType };
      });
      setProjectTypesList(project_typesList);
    }
  };

  const getProjectTypesForMarket = (marketId, project_types) => {
    let projectTypes = [];
    if (project_types && project_types.reduce) {
      projectTypes = project_types.reduce((filtered, project_type) => {
        if (project_type.project_templates && project_type.project_templates.length > 0) {
          const belongsToMarket = project_type.project_templates.find(project_template => {
            if (project_template.markets) {
              return project_template.markets.find(projectTemplateMarket => {
                return projectTemplateMarket.id == marketId;
              });
            }
            return false;
          });
          if (belongsToMarket) {
            filtered.push(project_type);
          }
        }
        return filtered;
      }, []);
    }
    return projectTypes;
  };

  const handleProjectTypeSelection = async(type, option) => {
    if (option) {
      setSelectedProjectType(option.project_type);
      if (option.project_type.project_templates) {
        let validProjectTemplates = option.project_type.project_templates.filter(pt => {
          const hasMarket = pt.markets ? pt.markets.filter(mark => {
            return selectedMarket.id == mark.id;
          }) : [];
          return pt.published_at && hasMarket.length > 0;
        });

        let mostRecentProjectTemplates = validProjectTemplates.reduce((accu, project_template) => {
          if (!accu[project_template.group_identifier]) {
            accu[project_template.group_identifier] = {
              type: project_template.id,
              name: 'V' + project_template.version + ' | ' + project_template.name,
              version: project_template.version,
              project_template: project_template,
            };
          } else if (project_template.version > accu[project_template.group_identifier].version) {
            accu[project_template.group_identifier] = {
              type: project_template.id,
              name: 'V' + project_template.version + ' | ' + project_template.name,
              version: project_template.version,
              project_template: project_template,
            };
          }
          return accu;
        }, {});

        setProjectTemplatesList(Object.values(mostRecentProjectTemplates));
      }
    }
  };

  const handleProjectTemplateSelection = (type, option) => {
    if (option) {
      setSelectedProjectTemplate(option.project_template);
    }
  };

  const handleNameChange = (e) => {
    setProjectName(e.target.value);
  };

  const handleProjectGroupsRetrieval = async() => {
    ProjectGroupService.getProjectGroups(currentCompany.id).then(response=>{
      const projectGroups = [];
      response.data.map(rs=>{
        let pg = {
          type: rs.id,
          id: rs.id,
          name: rs.attributes.name,
        };
        projectGroups.push(pg);
      });
      setProjectGroupsList([intialProjectGroupListButton, ...projectGroups]);
    });
  };

  const handleProjectGroupSelection = (type, option) => {
    if (option && !option.selected) {
      if(option.type == 'create'){
        setIsCreateNewPGPopup(true);
      }
      else{ 
        setSelectedGroup(option);
      }
    }
    else {
      setSelectedGroup(null);
    }
  };

  const handleSaveProjectGroup = (name) => {
    ProjectGroupService.createProjectGroup(currentCompany.id, name).then(res=>{
      handleProjectGroupsRetrieval();
      let newGroup = {
        type: res.data.type,
        id: res.data.id,
        name: res.data.attributes.name,
      };
      handleProjectGroupSelection(newGroup.type, newGroup);
    });
  };

  const handleClosePopup = () => {
    setIsCreateNewPGPopup(false);
  };

  const formatDate = (date) => {
    let formattedDate = null;
    if (date) {
      let dateFormatter = new Date(date);
      let month = dateFormatter.getMonth() + 1;
      if (month < 10) {
        month = '0' + month;
      }
      let day = dateFormatter.getDate();
      if (day < 10) {
        day = '0' + day;
      }
      let year = dateFormatter.getFullYear();
      formattedDate = month + '/' + day + '/' + year;
    }
    return formattedDate;
  };

  const handleDueDateSelection = (date) => {
    setDue_date(date);
  };

  const onCalendarClose = () => {
    const elementToChangeFocus = document.getElementById('projectNameInput');
    if (elementToChangeFocus) {
      elementToChangeFocus.focus();
    }
  };

  const handleProjectedStartDateSelection = (date) => {
    setProjected_start_date(date);
  };

  const handleContractIdChange = (e) => {
    setContractId(e.target.value);
  };

  const handleGuidChange = (e) => {
    setGuid(e.target.value);
  };

  const handleCustomerSelection = (type, option) => {
    if (option && !option.selected) {
      setSelectedCustomer(option.type);
    }
    else {
      setSelectedCustomer([]);
    }
  };

  const handleCompanyUpdate = (company, action) => {
    const customers = company.customers;

    const companyCustomers = customers ? customers.map(customer => {
      let selected = false;
      return { type: customer.id, name: customer.name, selected };
    }) : [];
    setCustomersList(companyCustomers);
  };

  const getProjectManagers = (market) => {
    projectManagersDataSource.current = new DataSource('User', null, null, handleProjectManagersRetrieval);
    projectManagersDataSource.current.performAction('getProjectManagers', market);
  };

  const handleProjectManagersRetrieval = (projectManagers) => {
    const projectManagerExistsForMarket = projectManagers.filter((projectManager) => {
      return projectManager.markets.includes(selectedMarket && selectedMarket.id);
    });
    setProjectManagersList(projectManagerExistsForMarket);
  };

  const handlePMSelection = (type, option) => {
    if (option && option.selected) {
      setSelectedProjectManager(option.user);
    }
    else {
      setSelectedProjectManager(null);
    }
  };

  const handleNotifyMultipleSelection = (multipleSelections, selectedOption) => {
    const updatedNotifyUsers = [...notifyUsers, ...selectedOption];
    setNotifyUsers(updatedNotifyUsers);
  };

  const createNotifyMemberArray = (userList, type) => {
    if (userList) {
      return userList.map(user => {
        return <UserAvatar id={'user-avatar-task-crud' + type + user.id} key={'user-avatar-task-crud' + type + user.id} user={user} small={true} />;
      });
    }
    else {
      return null;
    }
  };

  const renderProjectContacts = () => {
    let contactList = [];
    const unassignedMarketUsers = getUnassignedMarketUsers(allMarketUsers);
    const projectContacts = (project_contacts) || (selectedLocation && selectedLocation.project_contacts);
    if(projectContacts && projectContacts.length) {
      for (let project_contact of projectContacts) {
        // add selected to options list
        const contactMarketUsers = Object.assign([], unassignedMarketUsers);
        contactMarketUsers.push(project_contact.user);
        
        contactList.push(
          <ProjectContact
            key={'project-contact-'+project_contact.id}
            contact={project_contact}
            contactMarketUsers={contactMarketUsers}
            handleDeleteProjectContact={handleDeleteProjectContact}
            handleSaveProjectContact={handleSaveProjectContact}
          />
        );
      }
    }
    if ((!projectContacts || projectContacts.length < 2) && unassignedMarketUsers) {
      //maximum of 2 key contacts
      const randomId = Math.floor(Math.random() * 1000);
      const newContact = (
        <ProjectContact
          key={'location-contact-new' + randomId}
          contactMarketUsers={unassignedMarketUsers} 
          handleDeleteProjectContact={handleDeleteProjectContact}
          handleSaveProjectContact={handleSaveProjectContact} />
      );
      contactList.push(newContact);
    }

    return (
      <div className="column project-contacts">
        <div className="caption">Project Contacts</div>
        <div className='project-contacts-container'>
          {contactList}
        </div>
      </div>
    );
  };

  const getUnassignedMarketUsers = (marketUsers) => {
    const assignedUserIds = new Set();
    if (project_contacts) {
      for (let projectContact of project_contacts) {
        if (projectContact.user) {
          assignedUserIds.add(projectContact.user.id);
        }
        else if (projectContact.firstName) {
          assignedUserIds.add(projectContact.user.id);
        }
      }
    }
    if (marketUsers) {
      return marketUsers.filter((marketUser) => {
        return (!assignedUserIds.has(marketUser.id));
      });
    }
    return [];
  };

  const handleUsersRetrieval = (marketUsers, action, acData, fetchedData) => {
    if (marketUsers) {
      setAllMarketUsers(marketUsers.users);
    }
  };

  const handleDeleteProjectContact = (projectContactId) => {
    setProjectContact(null);
  };
  
  const handleSaveProjectContact = (projectContactId, editedContact) => {
    setProjectContact(editedContact);
  };

  const handleNotesChange = (e) => {
    setNotes(e.target.value);
  };

  const handleCustomFieldTypeSelection = (type, option) => {
    if (option) {
      const editedCustomSetting = Object.assign({}, customSetting, { setting_type: parseInt(type, 10) });
      setSelectedFieldType(option);
      setCustomSetting(editedCustomSetting);
    }
  };

  const handleCancelCustomSetting = () => {
    setCustomSetting({});
    setSelectedFieldType(customFieldTypes[0]);
  };

  const handleAddCustomSetting = () => {
    const tempCustomProjectSettings = customProjectSettings;
    if(customSetting){
      if(!customSetting.setting_type){
        const editedCustomSetting = Object.assign({}, customSetting, { setting_type: 1 });
        tempCustomProjectSettings.push(editedCustomSetting);
      }
      else{
        tempCustomProjectSettings.push(customSetting);
      }
      setCustomProjectSettings(tempCustomProjectSettings);
      setCustomSetting({});
    }
  };

  const handleFieldChanges = (field) => {
    if (!(customProjectSettings.length > 0)) {
      setCustomProjectSettings([field]);
    }
    else {
      let tempCustomProjectSettings = customProjectSettings;
      for (var i = 0; i < customProjectSettings.length; i++) {
        if (customProjectSettings[i].id == field.id) {
          switch (tempCustomProjectSettings[i].setting_type) {
          case 1:
            tempCustomProjectSettings[i].text_value = field.text_value;
            break;
          case 2:
            tempCustomProjectSettings[i].float_value = field.float_value;
            break;
          case 3:
            tempCustomProjectSettings[i].integer_value = field.integer_value;
            break;
          case 4:
            tempCustomProjectSettings[i].boolean_value = field.boolean_value;
            break;
          default:
            break;
          }
          break;
        }

      }
      setCustomProjectSettings(tempCustomProjectSettings);
    }
  };

  const handleSettingDelete = (customSetting) => {
    const message = textMap.projectSettingArchiveQuestion;
    dataModel.showGlobalModal('SYSTEM_POPUP', {
      message: message,
      cancelButtonText: textMap.no.toUpperCase(),
      okButtonText: textMap.yes.toUpperCase(),
      width: 300,
      height: 175,
      handleOwnerOk: () => {
        doDeleteProjectSetting(customSetting);
      },
    });
  };

  const doDeleteProjectSetting = (customSetting) => {
    const updatedCustomProjectSettings = customProjectSettings.filter(
      (setting) => setting.id !== customSetting.id
    );

    setCustomProjectSettings(updatedCustomProjectSettings);
  };

  const handleValueChanged = (e) => {
    let tempCustomSetting = Object.assign({}, customSetting);
    const dataId = e.target.getAttribute('data-id');
    switch (dataId) {
    case 'text-value-field':
      tempCustomSetting.text_value = e.target.value;
      break;
    case 'decimal-value-field':
      tempCustomSetting.float_value = parseFloat(e.target.value);
      break;
    case 'integer-value-field':
      tempCustomSetting.integer_value = isNaN(parseInt(e.target.value, 10)) ? '' : parseInt(e.target.value, 10);
      break;
    case 'units-value-field':
      tempCustomSetting.units = e.target.value;
      break;
    case 'maximum-value-field':
      tempCustomSetting.max_value = isNaN(parseInt(e.target.value, 10)) ? '' : parseInt(e.target.value, 10);
      break;
    case 'minimum-value-field':
      tempCustomSetting.min_value = isNaN(parseInt(e.target.value, 10)) ? '' : parseInt(e.target.value, 10);
      break;
    case 'setting-label':
      tempCustomSetting.setting_label = e.target.value;
      break;
    case 'setting-notes':
      tempCustomSetting.notes = e.target.value;
      break;
    case 'selected-value-field':
      const selected_values = e.target.value.split(';');
      const preJsonArray = [];
      for (var i = 0; i < selected_values.length; i++) {
        preJsonArray.push({ name: selected_values[i] });
      }
      tempCustomSetting.selection_value = JSON.stringify(preJsonArray);
      break;
    default:
      break;
    }
    setCustomSetting(tempCustomSetting);
  };

  const createSettingEditor = (selectedOption) => {
    let settingEditor = null;

    switch (parseInt(selectedOption.type, 10)) {
    case 1:
      break;
    case 2:
      settingEditor = createDecimalEditor();
      break;
    case 3:
      settingEditor = createIntegerEditor();
      break;
    case 4:
      break;
    case 5:
      settingEditor = createSelectionEditor();
      break;
    default:
      break;
    }
    return settingEditor;
  };

  const createDecimalEditor = () => {
    const editor = <div className="entry-field">
      <div className="label">UNITS</div>
      <Input className="field input-field" value={customSetting.units} placeholder="Units (feet, degrees, etc)" data-id="units-value-field" onChange={handleValueChanged} />
    </div>;
    return editor;
  };

  const createIntegerEditor = () => {
    const editor = <div>
      <div className="entry-field">
        <div className="label">UNITS</div>
        <Input className="field input-field" value={customSetting.units} placeholder="Units (feet, degrees, etc)" data-id="units-value-field" onChange={handleValueChanged} />
      </div>
      <div className="double-entry-field">
        <div className="half-field">
          <div className="label">MIN VALUE</div>
          <Input className="field input-field" value={customSetting.min_value} placeholder="Enter a Number" data-id="minimum-value-field" onChange={handleValueChanged} />
        </div>
        <div className="half-field">
          <div className="label">MAX VALUE</div>
          <Input className="field input-field" value={customSetting.max_value} placeholder="Enter a Number" data-id="maximum-value-field" onChange={handleValueChanged} />
        </div>
      </div>
    </div>;
    return editor;
  };

  const createSelectionEditor = () => {

    const optionsParsed = customSetting.selection_value ? JSON.parse(customSetting.selection_value) : [];

    let optionString = '';
    optionsParsed.map(option => {
      optionString += option.name + ';';
      return option.name;
    });
    optionString = optionString.slice(0, optionString.length - 1);

    return (
      <div className="entry-field selection-options">
        <div className="label">LIST SELECTION OPTIONS, SEPARATED BY A SEMI-COLON</div>
        <Textarea className="textarea-input-field selection-options field" value={optionString} placeholder="Enter Options" data-id="selected-value-field" onChange={handleValueChanged} />
      </div>
    );
  };

  const handleAddMember = () => {
    if (displayAddMember) {
      setCloseProjectMemberPopup(true);
    }
    else {
      const userElement = document.getElementById('add-member-button');
      let x = 0;
      let y = 0;
      if (userElement) {
        const rect = userElement.getBoundingClientRect();
        let parent = document.getElementById('project-crud-header');
        if (parent) {
          const parentRect = parent.getBoundingClientRect();
          x = rect.left - parentRect.left - 168;
          y = rect.top - parentRect.top + 53;
        }
      }
      setDisplayAddMember(true);
      setCloseProjectMemberPopup(false);
      setPopupPosition({ X: x, Y: y });
      setDisplayEditMember(false);
    }
  };

  const createMemberArray = () => {
    if (users) {
      return users.map(user => {
        const selected = selectedUser && user && user.id == selectedUser.id;
        return <UserAvatar id={'user-avatar-project-' + user.id} key={'user-avatar-project-' + user.id} user={user} selected={selected}
          handleSelected={handleSelectUser} handleMenuSelection={()=>{}} />;
      });
    }
    return null;
  };

  const handleSelectUser = (user) => {
    if (displayEditMember && selectedUser && user.id == selectedUser.id) {
      setDisplayEditMember(false);
    }
    else {
      const userElement = document.getElementById('user-avatar-project-' + user.id);
      let x = 0;
      let y = 0;
      if (userElement) {
        const rect = userElement.getBoundingClientRect();
        let parent = document.getElementById('project-crud-header');
        if (parent) {
          const parentRect = parent.getBoundingClientRect();
          x = rect.left - parentRect.left - 88;
          y = (rect.top - parentRect.top) + rect.height + 30;
        }
      }
      setCloseProjectMemberPopup(true);
      setPopupPosition({ X: x, Y: y });
      setDisplayEditMember(true);
      setSelectedUser(user);
    }
  };

  const handleAddUsersClose = () => {
    setDisplayAddMember(false);
    setDisplayEditMember(false);
  };

  const handleAddUsers = (toBeRemoved, toBeAdded) => {
    const updatedUsers = users.filter(
      user => !toBeRemoved.some(removedUser => removedUser.id === user.id)
    );
    const finalUsers = [...updatedUsers, ...toBeAdded];
    setUsers(finalUsers);
  };

  const handleInfoClose = () => {
    setDisplayedUserInfo(null);
  };

  const handleInfoOpen = (assignment) => {
    setDisplayedUserInfo(assignment);
  };

  const handleSearchLocation = (searchString) => {
    if(searchString && searchString.length > 2) {
      setLoadingLocations(true);
      const lowerSearchString = searchString.toLowerCase();
      const foundLocations = [];
      locationsService.search(searchString, '').then(response => {
        response.forEach(location => {
          if(location.name.toLowerCase().includes(lowerSearchString) && location.market.id === selectedMarket.id){
            foundLocations.push(location);
          }
        });
        if(foundLocations.length > 0){
          setLoadingLocations(false);
          createLocationOptions(foundLocations);
        }
        else{
          setLoadingLocations(false);
          createLocationOptions([{}]);
        }
      })
      .catch(error=>{
        setLoadingLocations(false);
        createLocationOptions([{}]);
      });
      
    }
    else if(searchString===''){
      locationsDataSource.current.current().then(()=>{
        setLoadingLocations(false);
      });
    }
  };

  const handleLocationAdd = (options) => {
    if(totalLocation > options.length){
      setLoadingLocations(true);
      locationsDataSource.current.next().then(()=>{
        setLoadingLocations(false);
      });
    }
  };

  let project_typesPicker =
    <div className="entry-field">
      <div className="label required">{textMap.projectType.toUpperCase()}</div>
      <div id="project_typePickerField" className={'field combo' + (!projectTypesList || projectTypesList.length == 0 ? ' inactive' : '')}>
        <ComboBox
          id={'project_typePicker'}
          options={projectTypesList}
          currentOption={selectedProjectType}
          hasBorder={false}
          underlined={false}
          width={259}
          small={true}
          height={24}
          displayFontStyle={{ fontSize: '12px' }}
          handleSelection={handleProjectTypeSelection}
          placeHolderText={textMap.projectType}
        />
        {loadingProjectTypes && <LoadingDots />}
      </div>
    </div>;

  let project_templatesPicker = null;
  if (selectedProjectType && selectedMarket) {
    project_templatesPicker =
      <div className="entry-field">
        <div className="label required">{textMap.projectTemplate.toUpperCase()}</div>
        <div id="project_templatePickerField" className={'field combo' + (projectTemplatesList && projectTemplatesList.length == 0 ? ' inactive' : '')}>
          <ComboBox
            id={'project_templatePicker'}
            options={projectTemplatesList}
            currentOption={selectedProjectTemplate}
            hasBorder={false}
            underlined={false}
            width={259}
            small={true}
            height={24}
            displayFontStyle={{ fontSize: '12px' }}
            handleSelection={handleProjectTemplateSelection}
            placeHolderText={textMap.projectTemplate}
          />
        </div>
      </div >;
  }

  const locationContacts = selectedLocation && selectedLocation.location_users ? selectedLocation.location_users.map(user => {
    if (user && user.user) {
      return (
        <div key={'location-contact-' + user.user.id} className='location-contacts-row'>
          <div className='location-user-title'>{user.title ? user.title.toUpperCase() : 'NO TITLE'}</div>
          <div className='location-user-name'>{user.user.first_name} {user.user.last_name}</div>
        </div>);
    }
    else return null;
  }) : null;

  let locationEntry =
    <div className="column column-1">
      <div className="caption">{textMap.projectLocation}</div>
      <div className="entry-container">
        <div className="entry-field">
          <div className="label required">{textMap.markets.toUpperCase()}</div>
          <div id="marketPickerField" className="field combo">
            <ComboBox
              id={'marketPicker'}
              key={'marketPicker'}
              options={marketsList}
              currentOption={selectedMarket ? { type: selectedMarket.id, name: selectedMarket.code, market: selectedMarket } : null}
              hasBorder={false}
              underlined={false}
              defaultText="Select a Market"
              noneAvailabelText={loadingMarkets ? textMap.noneSelected : undefined}
              width={259}
              small={true}
              height={20}
              displayFontStyle={{ fontSize: '12px' }}
              handleSelection={handleMarketSelection}
              placeHolderText={textMap.market}
              clearSelected={true}
              handleFetchOptions={getMarkets}
            />
            {loadingMarkets && <LoadingDots />}
          </div>
        </div>

        <div className="entry-field">
          <div className="label required">{textMap.siteName.toUpperCase()}</div>
          <div id="locationPickerField" className={'field combo' + (!locationsList || locationsList.length == 0 ? ' inactive' : '')}>
            <ComboBox
              id={'locationPicker'}
              key={'locationPicker'}
              options={locationsList}
              showSearchBar={true}
              handleSearchValue={handleSearchLocation}
              currentOption={selectedLocation}
              hasBorder={false}
              underlined={false}
              noneAvailabelText={loadingLocations ? textMap.noneSelected : undefined}
              width={259}
              small={true}
              height={20}
              handleAddOption={handleLocationAdd}
              displayFontStyle={{ fontSize: '12px' }}
              handleSelection={handleLocationSelection}
              placeHolderText={textMap.location}
              clearSelected={true}
              handleFetchOptions={getLocations}
              disabled={!locationsList || locationsList.length == 0}
              dontSortMenu={true}
            />
            {loadingLocations && <LoadingDots />}
          </div>
        </div>

        <div className="entry-field">
          <div className="label required">{textMap.locationId.toUpperCase()}</div>
          <Input className={'field input-field guid-search' + (!locationsList || locationsList.length == 0 ? ' inactive' : '')} value={selectedLocation ? selectedLocation.guid : ''} 
            disabled={loadingLocations} />
        </div>

        <div className="address-field" id="address-cont">
          <div className="label">{textMap.address}</div>
          <div className="address"><p>{selectedLocation && selectedLocation.address ? selectedLocation.address + ' ' : ''}</p>
            <p>{selectedLocation ? (selectedLocation.city ? selectedLocation.city + ', ' : '') + (selectedLocation.state || '') +
              ' ' + (selectedLocation.zip || '') : ''}</p>
          </div>
        </div>

        <div className="address-field latitude">
          <div className="label">{textMap.latitude}</div>
          <div className="address"><p>{selectedLocation && selectedLocation.latitude || projectLocation && projectLocation.latitude || ''}</p></div>
        </div>

        <div className="address-field longitude">
          <div className="label">{textMap.longitude}</div>
          <div className="address"><p>{selectedLocation && selectedLocation.longitude || projectLocation && projectLocation.longitude || ''}</p></div>
        </div>

        {project_typesPicker}
        {project_templatesPicker}
      </div>
      <div className='location-contacts'>
        <div className='caption'>Location Contacts</div>
        {locationContacts}
      </div>
    </div>;

  let dateFormatter = created_at ? new Date(created_at) : new Date();
  let createDate = dateFormatter ? dateFormatter.toLocaleDateString() : 'No Date Set';
  const dueDate = formatDate(due_date);
  const actualStartDate = formatDate(null);

  let notifyAvatars = null;
  if (notifyUsers.length > 1) {
    const notifyImages = createNotifyMemberArray(notifyUsers, 'notify');
    notifyAvatars = <div className="member-display">
      <div className="member-array">
        {notifyImages}
      </div>
    </div>;
  }

  const projectContacts = renderProjectContacts();

  let projectInformationEntry =
  <div className="column column-2">
    <div className="caption">{textMap.projectInformation}</div>
    <div className="entry-container">
      <div className="entry-field">
        <div className="label required">{textMap.name.toUpperCase()}</div>
        <Input className="field input-field" value={projectName} onChange={handleNameChange} id="projectNameInput"/>
      </div>
      <div className="entry-field">
        <div className="label">{'PROJECT GROUP'}</div>
        <div className="field combo">
          <ComboBox
            id={'projectGroupPicker'}
            key={'projectGroupPicker'}
            options={projectGroupsList}
            currentOption={selectedGroup}
            hasBorder={false}
            underlined={false}
            width={259}
            small={true}
            height={24}
            displayFontStyle={{ fontSize: '12px' }}
            handleSelection={handleProjectGroupSelection}
            placeHolderText={textMap.customer}
            showTooltip={true}
          />
        </div>
      </div>
      <div className="double-entry-field">
        <div className="half-field">
          <div className="label">{textMap.createDate.toUpperCase()}</div>
          <div className="field inactive">{createDate}</div>
        </div>
        <div className="half-field">
          <div className="label">{textMap.dueDate.toUpperCase()}</div>
          {disableDatePicker ?
            <div className="field inactive">{dueDate}</div> :
            <div className="field">
              <DatePicker
                selected={due_date}
                handleDateSelection={handleDueDateSelection}
                minDate={moment()}
                placeHolderText={'MM/DD/YYYY'}
                width={126}
                popperPlacement={'bottom-end'}
                value={due_date}
                dateFormat="MM/DD/YYYY"
                onCalendarClose={onCalendarClose}
              />
            </div>
          }
        </div>
      </div>
      <div className="double-entry-field">
        <div className="half-field">
          <div className="label">PROJECTED START DATE</div>
            <div className="field">
              <DatePicker
                selected={projected_start_date ? formatDate(projected_start_date): null}
                handleDateSelection={handleProjectedStartDateSelection}
                minDate={null}
                placeHolderText={'MM/DD/YYYY'}
                width={126}
                popperPlacement={'bottom-end'}
                value={projected_start_date ? formatDate(projected_start_date): null}
                dateFormat="MM/DD/YYYY"
                onCalendarClose={onCalendarClose}
              />
            </div>
        </div>
        <div className="half-field">
          <div className="label">ACTUAL START DATE</div>
          <div className="field inactive">{actualStartDate}</div>
        </div>
      </div>
      <div className="entry-field">
        <div className="label">CONTRACT ID</div>
        <Input className="field input-field" value={contractId} onChange={handleContractIdChange} />
      </div>
      <div className="entry-field">
        <div className="label">PROJECT ID</div>
        <Input className="field input-field" value={guid} onChange={handleGuidChange} />
      </div>
      <div className="entry-field">
        <div className="label">{textMap.customer.toUpperCase()}</div>
        <div className="field combo">
          <ComboBox
            id={'customerPicker'}
            key={'customerPicker'}
            options={customersList}
            currentOption={selectedCustomer}
            hasBorder={false}
            underlined={false}
            width={259}
            small={true}
            height={24}
            displayFontStyle={{ fontSize: '12px' }}
            handleSelection={handleCustomerSelection}
            placeHolderText={textMap.customer}
            // clearSelected={!customFieldType}
          />
        </div>
      </div>
      <div className="entry-field">
        <div className="label">{textMap.projectManager.toUpperCase()}</div>
        <div className="field combo">
          <SelectUserComboBox
            id={'pmPicker'}
            width={259}
            height={24}
            hasBorder={false}
            multiSelect={false}
            small={true}
            menuBelow={true}
            displayFontStyle={{ fontSize: '12px' }}
            handleSelection={handlePMSelection}
            currentSelectedUser={selectedprojectManager}
            users={projectManagersList}
            defaultText={projectManagersList ? null : 'First Select a Market'}
          />
        </div>
      </div>
      <div className="entry-field">
        <div className="label">NOTIFY AFTER COMPLETION</div>
        <div className="field combo">
          <SelectUserComboBox
            key="notify-user"
            width={259}
            hasBorder={false}
            multiSelect={true}
            height={24}
            selectedUsers={notifyUsers}
            menuBelow={true}
            handleMultipleSelection={handleNotifyMultipleSelection}
            small={true}
            displayFontStyle={{ fontSize: '12px' }}
            useMultiTab={true}
            users={users}
            defaultText={users && users.length > 0 ? null : 'Assign Project Members to add users'}
          />
        </div>
        {notifyAvatars}
      </div>
    </div>
    {projectContacts}
  </div>;
  
  const currentFieldType = selectedFieldType ? selectedFieldType : customFieldTypes[0];
  const settingEditor = createSettingEditor(currentFieldType);

  let projectNotesAndCustomFieldEntry = 
    <div className="column column-3">
      <div className="caption">{textMap.projectNotes}</div>
      <div className="entry-container">
        <div className="notes-field">
          <div className="label">{textMap.notes.toUpperCase()}</div>
          <Textarea className="field multi-line-input-field wide" onChange={handleNotesChange} value={notes} />
        </div>
      </div>
      <div className="custom-fields">
        <div className="caption">{textMap.projectCustomFields}</div>
        <div className="custom-field-columns">
          <div className="left-side">
            <div className="entry-container">
              <div className="entry-field">
                <div className="label">{textMap.fieldType.toUpperCase()}</div>
                <div id="customFieldField" className="field combo">
                  <ComboBox
                    id={'customFieldTypePicker'}
                    key={'customFieldTypePicker'}
                    options={customFieldTypes}
                    currentOption={selectedFieldType}
                    hasBorder={false}
                    underlined={false}
                    width={259}
                    small={true}
                    height={24}
                    displayFontStyle={{ fontSize: '12px' }}
                    handleSelection={handleCustomFieldTypeSelection}
                    placeHolderText={textMap.fieldType}
                  />
                </div>
              </div>
              <div className="entry-field">
                <div className="label">{textMap.fieldLabel.toUpperCase()}</div>
                <Input className="field input-field" value={customSetting.setting_label || ''} data-id="setting-label" onChange={handleValueChanged} />
              </div>
              <div className="notes-field small">
                <div className="label">{textMap.notesInstructions.toUpperCase()}</div>
                <Textarea className="field multi-line-input-field" value={customSetting.notes || ''} data-id="setting-notes" onChange={handleValueChanged} />
              </div>
              {settingEditor}
              <div className="add-setting-footer">
                <div className="cancel-button" onClick={handleCancelCustomSetting} />
                <div className={`add-button ${!customSetting.setting_label ? 'disabled' : ''} `} onClick={handleAddCustomSetting}>
                  {textMap.add.toUpperCase()}
                </div>
              </div>
            </div>
          </div>
          <div className="right-side">
            <div className="custom-fields-list">
              <DataCollector fields={customProjectSettings}
                handleChanges={handleFieldChanges}
                handleSettingDelete={handleSettingDelete}
                selectedField={selectedCustomSetting}
                height={265} />
            </div>
          </div>
        </div>
      </div>
    </div>;

  const memberImages = createMemberArray();

  let memberSelector = null;
  if (!currentCompany.admin_company) {
    memberSelector = (
      <div className="member-selection">
        <div className="label">
          {textMap.members.toUpperCase()}
        </div>
        <div className="member-container">
          <div className="add-member-button" id="add-member-button" onClick={handleAddMember}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
          <div className="member-array">
            {memberImages}
          </div>
        </div>
      </div>
    );
  }

  let addMemberPopup = null;
  if (displayAddMember) {
    addMemberPopup = (
      <SelectProjectMemberPopup
        handlePopupClose={handleAddUsersClose}
        requestClose={closeProjectMemberPopup}
        project={project}
        top={popupPosition.Y}
        left={popupPosition.X + 100}
        multiSelect={true}
        type="add"
        skipProjectFetch={true}
        handleChangeMembers={handleAddUsers}
      />
    );
  }

  return(
    <div className="project-crud">
      {isCreateNewPGPopup && <CreateNewProjectGroup handleClosePopup={handleClosePopup} handleSavePG={handleSaveProjectGroup}/>}
      <div className="project-crud-header" id="project-crud-header">
        {addMemberPopup}
        <div className="project-info">
          <div className="project-identity">
            <div className="project-name">
              {projectName || 'New Project'}
            </div>
            <div className='project-details'>
              <div className='details-ids'>
                <div className="details-guid">
                  {'ID: ' + guid}
                </div>
                <div className="details-id">
                  {'Contract ID: ' + contractId}
                </div>
              </div>
              <div className="details-template">
                {selectedProjectTemplate && selectedProjectTemplate.name ? 
                'Created From Template: ' + selectedProjectTemplate.name + ' | V' + selectedProjectTemplate.version 
                : 'Created From Template: null' }
              </div>
            </div>
          </div>
        </div>
        <div className="project-control">
          <div className="cancel-button" onClick={handleCancelCreateProject} />
          <div className={'save-button' + (!areRequiredFieldFilled ? ' disabled' : '')} onClick={areRequiredFieldFilled && handleSaveProject}>
            {textMap.save.toUpperCase() + ' ' + textMap.project.toUpperCase()}
          </div>
          <div className='divider' style={{ borderColor: accent_color }} />
          {memberSelector}
          <KeyMemberDisplay
            project={project}
            build={build}
            displayedUserInfo={displayedUserInfo}
            handleInfoOpen={handleInfoOpen}
            handleInfoClose={handleInfoClose}
            isLeftDividerHide={true}
            locationUsers={selectedLocation ? selectedLocation.location_users : null}
            projectContacts={projectContact}
          />
        </div>
      </div>
      <div className="project-crud-scroller">
        <div className="project-crud-body">
          {locationEntry}
          {projectInformationEntry}
          {projectNotesAndCustomFieldEntry}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {

  return {
    dataModel: dataModel,
    currentUser: state.new_users ? state.new_users.currentUser : null,
    currentCompany: state.new_companies ? state.new_companies.currentCompany : null,
  };
};

export default withRouter(connect(mapStateToProps)(CreateNewProject));



// WEBPACK FOOTER //
// ./src/containers/ProjectsContainer/ProjectCRUD/CreateNewProject/index.js